import React from 'react';
import Contact from './Contact';
import About from './About';
import ProjectList from './ProjectList';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

class Main extends React.Component{
	render(){
		return(
				<main>
					<BrowserRouter>
					<Switch>
						<Route path="/" exact component={ProjectList} />
					    <Route path="/about" component={About} />
					    <Route path="/contact" component={Contact} />
					    <Redirect from="*" to="/" /> 

					</Switch>
					</BrowserRouter>
				</main>
		)
	}
}

export default Main;


/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/